import { InsuranceSubProduct } from '@src/types';

export const getInsuranceSum = (subobjects: InsuranceSubProduct[]) =>
  subobjects.reduce((acc, { defaultInsuranceSum }) => {
    acc += Number(defaultInsuranceSum);
    return acc;
  }, 0);
